// constants/testIds/trustdime.js — TrustDime app testid registry
export const LANDING = {
  ctaGetStarted: "landing-cta-get-started",
  ctaPricing: "landing-cta-pricing",
  navLogin: "landing-nav-login",
  navSignup: "landing-nav-signup",
  planCard: (id) => `landing-plan-${id}`,
  planCta: (id) => `landing-plan-cta-${id}`,
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  orgInput: "auth-org-input",
  submitButton: "auth-submit-button",
  switchMode: "auth-switch-mode",
  googleButton: "auth-google-button",
  errorBanner: "auth-error-banner",
};

export const NAV = {
  userMenu: "nav-user-menu",
  logout: "nav-logout",
  sidebarItem: (slug) => `sidebar-${slug}`,
};

export const EXPENSE = {
  newButton: "expense-new-button",
  table: "expense-table",
  row: (id) => `expense-row-${id}`,
  status: (id) => `expense-status-${id}`,
  // form
  receiptFile: "expense-receipt-file",
  runOcr: "expense-run-ocr",
  vendorInput: "expense-vendor-input",
  amountInput: "expense-amount-input",
  currencyInput: "expense-currency-input",
  dateInput: "expense-date-input",
  programSelect: "expense-program-select",
  categorySelect: "expense-category-select",
  notesInput: "expense-notes-input",
  submit: "expense-submit",
  ocrConfidence: "expense-ocr-confidence",
};

export const APPROVAL = {
  approveBtn: (id) => `approve-${id}`,
  rejectBtn: (id) => `reject-${id}`,
  infoBtn: (id) => `info-${id}`,
  decisionNote: "approval-decision-note",
  confirm: "approval-confirm",
};

export const REIMBURSE = {
  markPaidBtn: (id) => `mark-paid-${id}`,
  paymentMethod: "reimburse-method",
  paymentRef: "reimburse-reference",
  confirm: "reimburse-confirm",
};

export const PROGRAM = {
  newButton: "program-new-button",
  nameInput: "program-name-input",
  budgetInput: "program-budget-input",
  descInput: "program-desc-input",
  submit: "program-submit",
  row: (id) => `program-row-${id}`,
  progress: (id) => `program-progress-${id}`,
};

export const MEMBER = {
  inviteButton: "member-invite-button",
  emailInput: "member-email-input",
  nameInput: "member-name-input",
  passwordInput: "member-password-input",
  roleSelect: "member-role-select",
  submit: "member-submit",
  roleChange: (id) => `member-role-change-${id}`,
  deleteButton: (id) => `member-delete-${id}`,
  editButton: (id) => `member-edit-${id}`,
  saveButton: (id) => `member-save-${id}`,
  cancelButton: (id) => `member-cancel-${id}`,
};

export const BILLING = {
  planCard: (id) => `billing-plan-${id}`,
  upgradeBtn: (id) => `billing-upgrade-${id}`,
  status: "billing-status",
};

export const DONOR = {
  page: "donor-page",
  programItem: (slug) => `donor-program-${slug}`,
};

export const DASHBOARD = {
  totalBudget: "metric-total-budget",
  totalSpent: "metric-total-spent",
  pendingAmount: "metric-pending-amount",
  reimbursableAmount: "metric-reimbursable-amount",
  programChart: "chart-program-spend",
  trendChart: "chart-monthly-trend",
};

export const STREAM = {
  newButton: "stream-new-button",
  nameInput: "stream-name-input",
  kindSelect: "stream-kind-select",
  funderInput: "stream-funder-input",
  totalInput: "stream-total-input",
  startInput: "stream-start-input",
  endInput: "stream-end-input",
  descInput: "stream-desc-input",
  submit: "stream-submit",
  row: (id) => `stream-row-${id}`,
  downloadPdf: (id) => `stream-pdf-${id}`,
  downloadCsv: (id) => `stream-csv-${id}`,
};

export const ACTIVITY = {
  list: (expenseId) => `activity-list-${expenseId}`,
  entry: (id) => `activity-${id}`,
};

export const SETTINGS = {
  exportTrustdime: "export-trustdime-csv",
  exportQuickbooks: "export-quickbooks-csv",
  exportAplos: "export-aplos-csv",
  gmailConnect: "gmail-connect-button",
  gmailDisconnect: "gmail-disconnect-button",
  gmailStatus: "gmail-status",
};
